import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import { CAPABILITIES } from "../constants/testIds";
import { Reveal } from "../components/Reveal";
import { motion } from "framer-motion";

const NumberLabel = ({ n }) => (
  <span className="font-mono text-[11px] tracking-[0.24em] text-white/40">
    {String(n).padStart(2, "0")}
  </span>
);

export const Capabilities = () => {
  const { t } = useI18n();
  const items = t.capabilities.items;

  return (
    <section
      id="capabilities"
      data-testid={CAPABILITIES.section}
      className="relative bg-black py-32 md:py-44 lg:py-52 px-6 md:px-10 lg:px-14 border-t border-white/5"
    >
      <div className="mx-auto max-w-[1440px]">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] items-end gap-10 mb-16 md:mb-24">
          <Reveal>
            <div className="flex items-center gap-4 text-[10px] tracking-[0.4em] uppercase font-mono text-white/50">
              <span className="w-8 h-px bg-white/30" />
              {t.capabilities.eyebrow}
            </div>
            <h2 className="mt-8 font-display tracking-display text-white text-[34px] sm:text-[44px] md:text-[60px] lg:text-[72px] leading-[1.02] font-medium max-w-[900px]">
              {t.capabilities.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-white/60 text-[14px] md:text-[15px] leading-[1.65]">
              {t.capabilities.sub}
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {items.map((item, i) => (
            <motion.article
              key={item.slug}
              data-testid={CAPABILITIES.card(item.slug)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.06 }}
              className="gaelon-card p-8 md:p-10 min-h-[280px] flex flex-col justify-between"
            >
              <div className="flex items-center justify-between">
                <NumberLabel n={i + 1} />
                <span className="w-7 h-7 inline-flex items-center justify-center border border-white/20 text-white/60 group-hover:text-white group-hover:border-white/60 transition-colors">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17 17 7M9 7h8v8" /></svg>
                </span>
              </div>

              <div>
                <h3 className="font-display text-white text-[24px] md:text-[28px] tracking-tight leading-[1.1] mb-4">
                  {item.title}
                </h3>
                <p className="text-white/55 text-[14px] leading-[1.65] max-w-[42ch]">
                  {item.desc}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
